// @flow strict

/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import { escapeHtml } from '@ta/common.text-html';

/**
 * Data required to populate an AggregateOffer JsonLD component
 */
export type JsonLdAggregateOfferData = {|
  /** The lowest price of any item on this search page */
  lowPrice: number,
  /** The highest price of any item on this search page */
  highPrice: number,
  /** The number of items on this search page */
  offerCount: number,
  /** The currency of the price numbers */
  priceCurrency: string,
|};

type AggregateOfferJsonLdProps = {|
  aggregateOfferData: JsonLdAggregateOfferData,
|};

const generateJsonLd = (ldObject: JsonLdAggregateOfferData) => ({
  '@context': 'http://schema.org',
  '@type': 'AggregateOffer',
  lowPrice: ldObject.lowPrice,
  highPrice: ldObject.highPrice,
  offerCount: ldObject.offerCount,
  priceCurrency: escapeHtml(ldObject.priceCurrency),
});

/* eslint-disable react/no-danger */
const AggregateOfferJsonLd = ({ aggregateOfferData }: AggregateOfferJsonLdProps) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(generateJsonLd(aggregateOfferData)) }}
  />
);

/* eslint-enable react/no-danger */
export default AggregateOfferJsonLd;
